import { Box, Button, Stack } from '@mui/material';

import { api, getAndValidateFirstFileFromFileList, useLoggedInAuthContext, useToast } from 'common';

import { DropZone } from '../../../../../../../../components/DragAndDrop';
import { useUploadFileContext } from '../../../../../../../KnowledgeBase/fileUploadContext';
import { useReactFlowViewContext } from '../../../../context/context';

interface AdditionalKnowledgeBaseFileUploadDropzoneProps {
  onBrowseFiles: () => void;
}

export function AdditionalKnowledgeBaseFileUploadDropzone(
  props: AdditionalKnowledgeBaseFileUploadDropzoneProps
) {
  const { onBrowseFiles } = props;
  const { showError } = useToast();
  const { setFile } = useUploadFileContext();
  const { hasPermission } = useLoggedInAuthContext();
  const { isEditable } = useReactFlowViewContext();

  if (!hasPermission.UpdateKnowledgeBaseFiles || !isEditable) {
    return (
      <Box>
        <Button
          variant="outlined"
          color="primary"
          onClick={() => onBrowseFiles()}
          disabled={!isEditable}
        >
          Browse Files
        </Button>
      </Box>
    );
  }

  return (
    <DropZone
      height="56px"
      onDrop={(files) => {
        try {
          const file = getAndValidateFirstFileFromFileList({
            files,
            validContentTypes: api.KnowledgeBaseFile.VALID_CONTENT_TYPES,
            maxFileSizeInBytes: api.KnowledgeBaseFile.MAX_KNOWLEDGE_BASE_FILE_SIZE_IN_BYTES,
          });
          setFile(file);
        } catch (error: unknown) {
          if (error instanceof Error) {
            showError(error.message);
          }
        }
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="flex-start"
        width="100%"
        height="100%"
        padding={1.5}
      >
        <Button variant="outlined" color="primary" onClick={() => onBrowseFiles()}>
          Browse Files
        </Button>
      </Stack>
    </DropZone>
  );
}
